import SelfServiceEntityHistoryTable from "./SelfServiceEntityHistoryTable";

export default SelfServiceEntityHistoryTable;
